import React, { useRef, useState, useEffect } from 'react';
import './trending.scss'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, Container, Grid, Link } from '@mui/material';
function VrShows() {

   const vrShowData = [
  {
    id: 1,
    title: "Dwarka Beneath the Sea",
    image: "/assets/trending/sea.webp",
  },
  {
    id: 2,
    title: "Varanasi After Sunset",
    image: "/assets/trending/varanasi.webp",
  },
  {
    id: 3,
    title: "Kashi",
    image: "/assets/trending/varanasi.webp",
  },
  {
    id: 4,
    title: "Manikarnika",
    image: "/assets/trending/manikarna.webp",
  },
  
];
   return (
      <>
         <Box className="trendingPage vrShows" >
            <Container maxWidth="lg">
               <Grid container spacing={2} justifyContent="left" alignItems="center">
                  <Grid size={{ xl: 10, lg: 10, md: 12, sm: 12, xs: 12 }} >
                     <Box className="VrBannerText vrBannerFull">
                        <div>
                           <h1 className="mt-4">360 VR SHOWS</h1>
                           <p>Cinematic 360 experience form temples across the subcontinent-drag, look around, and lose yourself in real sanctums from wherever you are.
                           </p>
                           {/* <div className="d-flex gap-3 bannerButton">
                              <Box className="text-center mt-lg-3">
                                 <a href="#formBox" className="btn btn-success text-dark"><i className="fa fa-play ms-1 text-dark"></i> Play </a>
                              </Box>
                              <Box className="text-center mt-lg-3">
                                 <a href="/assets/trending/guideline.pdf" target="_blank" className="btn btn-warning text-dark"><i className="fa fa-arrow-right me-1 text-dark"></i>More Info </a>
                              </Box>
                           </div> */}
                        </div>
                     </Box>
                  </Grid>
               </Grid>
            </Container>
         </Box>

         <section className="darkTheme">
            
            <Box className="trendingSection">
               <Container maxWidth="lg">
                  <Grid container spacing={2} alignItems="stretch">
                     
                     {vrShowData.map((item) => (
                        <Grid
                           key={item.id}
                           size={{ xl: 3, lg: 3, md: 4, sm: 4, xs: 6 }}
                        >
                           <div className="swiperCitySlider">
                              <div className="templeCard templeDetailCard">
                              <img src={item.image} alt={item.title} />

                              <div className="overlay"></div>

                              <div className="cardContent">
                                 <h5>{item.title}</h5>
                              </div>
                              </div>
                           </div>
                        </Grid>
                        ))}


                     
                     
                  </Grid>


               </Container>
            </Box>
         </section>
      </>
   );
}
export default VrShows;